import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./RegisterPage.module.css";
import { API_BASE_URL } from "../apiConfig";

function RegisterPage() {
  const [contact, setContact] = useState(null);

  const contactPhone = "6506438555";

  const contactEmail = contact?.email || "EMAIL MISSING";

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/contact`)
      .then((response) => setContact(response.data))
      .catch((error) => console.error("Error fetching contact:", error));
  }, []);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.updateBox}>
        <h1 className={styles.titleText}>Register</h1>

        <p
          style={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          📧 Please send your registration details to:{" "}
          <a href={`tel:${contactPhone}`}>
            <strong>{contactPhone}</strong>
          </a>
          .
        </p>

        <p>
          Registration helps us ensure safety, trust, and a smooth experience
          for everyone.
        </p>
        <p>
          <strong>Choose one:</strong> Send <u>2 photos</u> (ID + selfie){" "}
          <strong>or</strong> <u>2 k‑org references</u>.
        </p>

        {/* 📦 Requirements Box */}
        <div className={styles.requirementsBox}>
          <h3 className={styles.subheading}>📋 Required Information</h3>
          <ul className={styles.checklist}>
            <li>Full Name</li>
            <li>Phone Number</li>
            <li>Age (18+)</li>
            <li>Ethnicity</li>
          </ul>

          <p className={styles.subheading}>
            <strong>Option 1: Provide 2 Photos</strong>
          </p>
          <ul className={styles.checklist}>
            <li>Selfie holding paper with today's date</li>
            <li>Photo ID</li>
          </ul>

          <p className={styles.subheading}>
            <strong>Option 2: Provide 2 References</strong>
          </p>
          <ul className={styles.checklist}>
            <li>k-org website link</li>
            <li>We ask references to confirm your info</li>
          </ul>
        </div>

        <p>
          <strong>Note:</strong> Only k‑org references are accepted.
        </p>

        <p>
          <strong>Note:</strong> Some k‑orgs may not reply. Have extra
          references ready.
        </p>
      </div>
    </div>
  );
}

export default RegisterPage;
